import React from 'react'
import About from './About'
import ObjectRenderer from '../ObjectRenderer'

export default class AboutPage extends React.Component {
  state={}
  componentDidMount() {
  }
  render() {
    const {t,className} = this.props
    return (
      <div className="mt-6">
        <h1 className="text-center content-title text-shadow">{t('key:about')}</h1>
        <div className={`main-content ${className||''} transparent-background`}>
          <ObjectRenderer t={t} languageKey="about" value={About} />
        </div>
      </div>
    )
  }
}
